import { render, staticRenderFns } from "./SendToLegalBox.vue?vue&type=template&id=065c10ef&"
import script from "./SendToLegalBox.js?vue&type=script&lang=js&"
export * from "./SendToLegalBox.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports